import { useState } from 'react';

export default function ReportModal({ mosque, date, onClose, onSubmit, isDark = false }) {
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    
    await onSubmit({
      mosque_id: mosque.id,
      lat: mosque.lat,
      lng: mosque.lng,
      note
    });
    
    setSubmitting(false);
  };

  const bgColor = isDark 
    ? 'linear-gradient(180deg, rgba(30,30,30,0.95) 0%, rgba(15,15,15,0.98) 100%)'
    : 'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.98) 100%)';
  const textColor = isDark ? '#ffffff' : '#1f2937';
  const subTextColor = isDark ? '#94a3b8' : '#64748b';
  const inputBg = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)';
  const inputBorder = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
  const inputColor = isDark ? '#ffffff' : '#1f2937';
  
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: isDark ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.3)',
      backdropFilter: 'blur(10px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000
    }} onClick={onClose}>
      <div style={{
        background: bgColor,
        borderRadius: '24px',
        padding: '24px',
        width: '90%',
        maxWidth: '380px',
        border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
        boxShadow: isDark 
          ? '0 25px 50px -12px rgba(0, 0, 0, 0.5)' 
          : '0 25px 50px -12px rgba(0, 0, 0, 0.15)'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <div style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 16px rgba(16, 185, 129, 0.4)'
          }}>
            <span style={{ fontSize: 24 }}>🕌</span>
          </div>
          <div>
            <h2 style={{ marginBottom: 4, color: textColor, fontSize: 18, fontWeight: 700 }}>রিপোর্ট করুন</h2>
            <p style={{ color: subTextColor, fontSize: 13 }}>{date}</p>
          </div>
        </div>
        
        <p style={{ color: textColor, marginBottom: 16, fontSize: 14 }}>
          <strong>{mosque.name}</strong>
        </p>
        
        <form onSubmit={handleSubmit}>
          <p style={{ marginBottom: 12, fontWeight: 600, color: textColor, fontSize: 14 }}>
            আজ এখানে বিরিয়ানি পাওয়া গেছে?
          </p>
          
          <textarea
            placeholder="অতিরিক্ত তথ্য (ঐচ্ছিক)..."
            value={note}
            onChange={e => setNote(e.target.value)}
            rows={3}
            style={{
              width: '100%',
              padding: '14px',
              background: inputBg,
              border: `1px solid ${inputBorder}`,
              borderRadius: '12px',
              marginBottom: 20,
              fontFamily: 'inherit',
              resize: 'none',
              color: inputColor,
              fontSize: 14
            }}
          />
          
          <div style={{ display: 'flex', gap: 12 }}>
            <button 
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                padding: '14px',
                background: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                border: `1px solid ${inputBorder}`,
                borderRadius: '12px',
                color: subTextColor,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 14
              }}
            >
              বাতিল
            </button>
            <button 
              type="submit"
              disabled={submitting}
              style={{
                flex: 1,
                padding: '14px',
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontWeight: 700,
                fontSize: 14,
                cursor: submitting ? 'not-allowed' : 'pointer',
                opacity: submitting ? 0.7 : 1,
                boxShadow: '0 4px 16px rgba(16, 185, 129, 0.4)'
              }}
            >
              {submitting ? 'পাঠাচ্ছি...' : 'রিপোর্ট করুন'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
